<template>
  <el-dialog
    v-drag
    title="邮箱密码"
    :visible.sync="dialogVisible"
    width="400px"
    :append-to-body="true"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :before-close="cancel"
  >
    <div class="content">
      <el-form :model="form">
        <el-form-item label="邮箱密码" style="margin-bottom: 0;">
          <el-input v-model="form.emailPassword" disabled></el-input>
        </el-form-item>
      </el-form>
    </div>
    <span slot="footer" class="footers flex_c_c">
      <div class="cancel flex_c_c" @click="cancel">关闭</div>
    </span>
  </el-dialog>
</template>

<script>
export default {
  props: {
    dialogVisible: Boolean,
    rowData: Object
  },
  data() {
    return {
      form: {
        emailPassword: ''
      }
    }
  },
  watch: {
    dialogVisible(val) {
      if (val) {
        this.form.emailPassword = this.rowData.supplierData?.emailPassword
      }
    }
  },
  methods: {
    cancel() {
      this.$emit('cancel')
    }
  }
}
</script>

<style lang="less" scoped>
.content {
  width: calc(100% - 40px);
  margin: 0 auto;
  /deep/ .el-form--label-top .el-form-item__label {
    line-height: 30px;
    padding: 0;
  }
}
.footers {
  width: 100%;
  & > div {
    width: 120px;
    height: 40px;
    border-radius: 4px 4px 4px 4px;
    font-size: 14px;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    cursor: pointer;
  }
  .cancel {
    background: #eeeeee;
    color: #666666;
    margin-right: 16px;
  }
}
</style>
